(() => {
  const html = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sectionSelector = [
    'main .mina-categories',
    'main .mina-products',
    'main .mina-reviews',
    'main .mina-routine',
    'main .mina-skincheck',
    'main .mina-community',
    'main .mina-magazine',
    'main .mina-faq',
    'main .mina-about-values',
    'main .mina-about-story',
    'main .mina-about-journey',
    'main .mina-about-human',
    'main .mina-contact__form-section',
    'main .mina-contact__faq',
    'main .mina-article__related'
  ].join(',');

  let observer;
  let scrollFrame;

  const show = (element) => {
    element.dataset.minaMotionReveal = 'visible';
    observer?.unobserve(element);
  };

  const setupReveals = (scope = document) => {
    if (reducedMotion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;

    observer ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) show(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: .08
    });

    scope.querySelectorAll(sectionSelector).forEach((element) => {
      if (element.dataset.minaMotionReveal) return;

      const bounds = element.getBoundingClientRect();
      if (bounds.top <= window.innerHeight * .92) return;

      element.dataset.minaMotionReveal = 'pending';
      observer.observe(element);
    });
  };

  const updateHeader = () => {
    scrollFrame = undefined;
    document.querySelectorAll('.mina-glass-header').forEach((header) => {
      header.classList.toggle('is-mina-scrolled', window.scrollY > 24);
    });
  };

  const requestHeaderUpdate = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(updateHeader);
  };

  const initialize = (scope = document) => {
    html.classList.add('mina-motion-enabled');
    setupReveals(scope);
    requestHeaderUpdate();
  };

  initialize();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) {
      observer?.disconnect();
      document.querySelectorAll('[data-mina-motion-reveal]').forEach(show);
    } else {
      setupReveals();
    }
  });
})();
